const state = {
    users: [],
    notifications:null,
    authedUser:null,
    autoids:'',
    unsubscribe:''


}

const getters = {
    customers: state => state.users.filter(item=>item.isadmin==false),
    notifications: state => state.notifications,
    authedUser: state => state.authedUser,
    autoids: state => state.autoids,

}

const actions = {
    createUser({commit}, user) {
        const { password, ...exclude } = user;
        const payload  = Object.assign({}, {...exclude});
        console.log(payload)


            firebase.auth().createUserWithEmailAndPassword(user.email, user.password).then(result => {
                // firebase.auth().currentUser.sendEmailVerification()
                // .then(() =>{
                //     commit("setNotifications",{message:'Check your email for verification!',type:'success'})
                    
                // })
                // .catch(err => {
                //     commit("setNotifications",{message:err.message,type:'error'})

                // });
    
                firebase.database().ref('users').child(result.user.uid).set(payload).then(save => {
                    commit("setNotifications",{message:'New user created successfully',type:'success'})

                }).catch(err => {
                    commit("setNotifications",{message:err.message,type:'error'})
                })
            }).catch(err => {
                commit("setNotifications",{message:err.message,type:'error'})
            })
        
    },
    signoutrequests(context) {
        firebase.auth().signOut()
            .then(() => {
                console.log("yes needed that")
                context.commit('logOutUser')
            })
    },
    passwordReset({commit}, email){
        firebase.auth().sendPasswordResetEmail(email).then(() => {
            commit('setNotifications',{message:'An email has been sent to your account',type:'success'})
        }).catch(err => {
            commit('setNotifications',{message:err.message,type:'error'})
        })
    },
    // JSON.stringify(payload)
    authenticatelogin(context, user_payload) {
        // 
       var unsubscribe = firebase.auth().onAuthStateChanged(user => {
            if (user) {
                console.log("auth state changed")
                firebase.database().ref('users').child(user.uid)
                    .once('value', snapshot => {
                        if (snapshot.val()) {

                        context.commit('setauthedUser', {
                                ...snapshot.val(),
                                id: snapshot.key})
                        }
                    })
                }
        })

        context.commit("setsubscribs",unsubscribe)

        firebase.auth().signInWithEmailAndPassword(user_payload.email, user_payload.password)
            .then(() => {
                console.log("auth completed")
            })
            .catch(error => {
                context.commit("setNotifications",{message:error.message,type:'error'})
            });
    },
    // LOGIN REGISTERED USER
    fetchUsers({commit},payload){
        firebase.database().ref('users').on('value', snapshot => {
            commit('setAllUsers', snapshot.val())
        })
    },
    fetchAutoIds({commit},payload) {
        firebase.database().ref('autoids').on('value', snapshot => {
            commit('setAutoIds', snapshot.val())
        })
    },
    updateAutoId({commit},payload) {
        let id=payload.id
        delete payload.id
        firebase.database().ref('autoids').update(payload)
        .then(()=>{
            console.log("autoid updated")
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })
    },
    updatePriceFlag({commit},payload) {
        let id=payload.id
        delete payload.id
        firebase.database().ref('users').child(id).update(payload)
        .then(()=>{
            commit("setNotifications",{message:'Status updated successfully',type:'success'})
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })
    },

 
}

const mutations = {
    setAutoIds: (state, payload) => {
        state.autoids=payload
    },
    setAllUsers: (state, payload) => {
        let users_Array=[]
        for(let key in payload) {
            payload[key].id=key
            users_Array.push(payload[key])
        }
        state.users=users_Array
    },
    setNotifications:(state,payload)=>{
        state.notifications=payload
    },  
    
    setauthedUser: (state, payload) => {
        if(localStorage.getItem("authedUser")==null) {
            console.log("came boi")
        localStorage.setItem("authedUser", JSON.stringify(payload));
        }
        console.log("auth user set")
        state.authedUser=payload
    }, 
    setsubscribs(state,payload){
        state.unsubscribe=payload
    },
    logOutUser(state,payload){
        state.authedUser=null
        console.log("yosho")
        localStorage.removeItem("authedUser");
        state.unsubscribe();

    } 


   
}

export default {
    state,
    actions,
    getters,
    mutations
}